import React, { useState, useEffect, useContext, memo, useCallback, useRef } from "react";
import { ProfileContext } from "../context/ProfileContext";
import { WerkerJobContext } from "../context/JobContextWerker";
import { db } from "../firebase";
import * as Sentry from "@sentry/react";
import { format } from "date-fns";
import {
  HEADERTEXT_TYPES,
  WORKFLOW_WERKER_TYPES,
  WORKFLOW_SCHEDULER_TYPES,
  PUSH_NOTIFICATION_TYPES,
  FB_COLLECTION_PATH,
} from "../functions/postActionTypes";
import { claimJobTransaction } from "../functions/claimJobTransaction";
import {
  query,
  where,
  onSnapshot,
  collectionGroup,
  getDocs,
  updateDoc,
  doc,
  setDoc,
  runTransaction,
  getDoc,
} from "firebase/firestore";
import { RouteComponentProps, useHistory } from "react-router-dom";
import {
  IonContent,
  IonPage,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonIcon,
  IonLabel,
  IonItem,
  IonAvatar,
  useIonAlert,
  IonFab,
  IonFabButton,
  IonBadge,
  IonList,
  IonLoading,
  useIonLoading,
  IonItemDivider,
  IonText,
  IonAccordionGroup,
  IonAccordion,
  IonFooter,
  IonToolbar,
  useIonViewWillLeave,
  useIonToast,
  IonModal,
  IonHeader,
  IonTitle,
  IonTextarea,
  IonAlert,
} from "@ionic/react";
import {
  chatboxOutline,
  cashOutline,
  arrowUndoOutline,
  navigate,
  closeSharp,
} from "ionicons/icons";
import "../theme/AppStyles.css";
import { WerkerSchedulerHeader } from "../components/WerkHeader";
import { fx_FB_SendNotification } from "../functions/Fx_SendPushNotification";
import { generateMapUrls, parseNotes2 } from "../functions/FX_ParseAndMap";
import { fx_FB_WerkerUpdateAll } from "../functions/Fx_WerkerUpdateAll";
import { fx_FB_WerkerFeedUpdateAll } from "../functions/fx_FB_WerkerFeedUpdateAll";
import { sendJobToSupport } from "../utils/chatUtils";
import { SUPPORT_MONKEY_ASSOCIATE } from "../constants/supportConstants";
import { LoadingScreen } from "../components/LoadingScreen";
import { useLoadTimeoutGuard } from "../hooks/useLoadTimeoutGuard";

interface ShiftDetailsProps
  extends RouteComponentProps<{
    jobDocId: string;
    uniqueJobDocId: string;
    schedUid: string;
  }> {}

const ShiftDetails: React.FC<ShiftDetailsProps> = memo(({ match }) => {
  const { usersID, profile } = useContext(ProfileContext);
  const history = useHistory();
  const [present] = useIonAlert();
  const [presentSupportConfirm] = useIonAlert();
  const [presentToast] = useIonToast();
  const [showSupportDetails, setShowSupportDetails] = useState(false);
  const [supportNote, setSupportNote] = useState("");
  const [isSendingToSupport, setIsSendingToSupport] = useState(false);
  const [remainingJobSlots, setRemainingJobSlots] = useState(0);
  useContext(WerkerJobContext);

  interface JobDocData {
    JobDocId: string;

    WerkerUid: string;
    WerkerFirstName: string;
    WerkerLastName: string;
    WerkerProfilePicURL: string;

    SchedulerUid: string;
    SchedFirstName: string;
    SchedLastName: string;
    SchedProfilePic: string;

    TotalJobSlots: number;
    UniqueJobDocId: string;
    JobIdentifier: string;
    Pay: string;
    Company: string;
    StartDate: string;
    EndDate: string;
    Location: string;
    LocationCoordinates: string;
    Notes: string;

    IsPaidJob: boolean;
    WerkersPaid: boolean;
    SchedJobStatus: string;
    WerkerJobStatus: string;
    PaidWerker: boolean;
    IsNewMessage: boolean;
    IsCancelled: boolean;
    ScheduledCount: number;
  }

  const [jobDocsScheduler, setJobDocsScheduler] = useState<JobDocData>({
    JobDocId: "",

    WerkerUid: "",
    WerkerFirstName: "",
    WerkerLastName: "",
    WerkerProfilePicURL: "",

    SchedulerUid: "",
    SchedFirstName: "",
    SchedLastName: "",
    SchedProfilePic: "",

    TotalJobSlots: 0,
    UniqueJobDocId: "",
    JobIdentifier: "",
    Pay: "",
    Company: "",
    StartDate: "2025-03-11T23:57:00",
    EndDate: "2025-03-11T23:57:00",
    Location: "",
    LocationCoordinates: "",
    Notes: "",

    IsPaidJob: false,
    WerkersPaid: false,
    SchedJobStatus: "",
    WerkerJobStatus: "",
    PaidWerker: false,
    IsNewMessage: false,
    IsCancelled: false,
    ScheduledCount: 0,
  });

  const [jobDocsScheduledWerkers, setJobDocsScheduledWerkers] = useState<JobDocData[]>([
    {
      JobDocId: "",

      WerkerUid: "",
      WerkerFirstName: "",
      WerkerLastName: "",
      WerkerProfilePicURL: "",

      SchedulerUid: "",
      SchedFirstName: "",
      SchedLastName: "",
      SchedProfilePic: "",

      TotalJobSlots: 0,
      UniqueJobDocId: "",
      JobIdentifier: "",
      Pay: "",
      Company: "",
      StartDate: "2025-03-11T23:57:00",
      EndDate: "2025-03-11T23:57:00",
      Location: "",
      LocationCoordinates: "",
      Notes: "",

      IsPaidJob: false,
      WerkersPaid: false,
      SchedJobStatus: "",
      WerkerJobStatus: "",
      PaidWerker: false,
      IsNewMessage: false,
      IsCancelled: false,
      ScheduledCount: 0,
    },
  ]);

  const [jobDocsWerker, setJobDocsWerker] = useState<JobDocData>({
    JobDocId: "",

    WerkerUid: "",
    WerkerFirstName: "",
    WerkerLastName: "",
    WerkerProfilePicURL: "",

    SchedulerUid: "",
    SchedFirstName: "",
    SchedLastName: "",
    SchedProfilePic: "",

    TotalJobSlots: 0,
    UniqueJobDocId: "",
    JobIdentifier: "",
    Pay: "",
    Company: "",
    StartDate: "2025-03-11T23:57:00",
    EndDate: "2025-03-11T23:57:00",
    Location: "",
    LocationCoordinates: "",
    Notes: "",

    IsPaidJob: false,
    WerkersPaid: false,
    SchedJobStatus: "",
    WerkerJobStatus: "",
    PaidWerker: false,
    IsNewMessage: false,
    IsCancelled: false,
    ScheduledCount: 0,
  });

  const hasLoadedShiftData = Boolean(jobDocsScheduler.UniqueJobDocId && jobDocsWerker.JobDocId);

  const navigateBackWithFallback = useCallback(() => {
    if (history.length > 1) {
      history.goBack();
      return;
    }

    history.replace("/Home");
  }, [history]);

  const { isLoading: isLoadingShiftData, hasTimedOut: hasTimedOutShiftData } = useLoadTimeoutGuard({
    hasLoaded: hasLoadedShiftData,
    resetKey: `${match.params.jobDocId}|${match.params.uniqueJobDocId}|${match.params.schedUid}`,
    timeoutMs: 10000,
  });

  const LinkToProfile = (profileUid: string) => {
    history.push({
      pathname: `/AssociateProfile/` + profileUid,
    });
  };

  useEffect(() => {
    const schedJobQuery = query(
      collectionGroup(db, FB_COLLECTION_PATH.JobsDocs),
      where("docStamp.userInfoFrom.uid", "==", match.params.schedUid),
      where("docStamp.userInfoTo.uid", "==", match.params.schedUid),
      where("jobInfo.core.uniqueJobId", "==", match.params.uniqueJobDocId)
    );

    try {
      const unsubscribe = onSnapshot(schedJobQuery, (querySnapshot) => {
        if (querySnapshot.empty) {
        } else {
          querySnapshot.forEach((docSnap) => {
            const jobDoc: any = docSnap.data();
            setJobDocsScheduler({
              JobDocId: match.params.jobDocId,

              WerkerUid: jobDoc.docStamp.userInfoTo.uid,
              WerkerFirstName: jobDoc.docStamp.userInfoTo.firstName,
              WerkerLastName: jobDoc.docStamp.userInfoTo.lastName,
              WerkerProfilePicURL: jobDoc.docStamp.userInfoTo.profilePicURL,

              SchedulerUid: jobDoc.docStamp.userInfoFrom.uid,
              SchedFirstName: jobDoc.docStamp.userInfoFrom.firstName,
              SchedLastName: jobDoc.docStamp.userInfoFrom.lastName,
              SchedProfilePic: jobDoc.docStamp.userInfoFrom.profilePicURL,

              TotalJobSlots: jobDoc.jobInfo.core.numJobSlots,
              UniqueJobDocId: jobDoc.jobInfo.core.uniqueJobId,
              JobIdentifier: jobDoc.jobInfo.core.shiftIdentifier,
              Pay: jobDoc.jobInfo.core.pay,
              Company: jobDoc.jobInfo.core.company,
              StartDate: jobDoc.jobInfo.core.dateTimeStart,
              EndDate: jobDoc.jobInfo.core.dateTimeFinish,
              Location: jobDoc.jobInfo.core.location,
              LocationCoordinates: jobDoc.jobInfo.core.locationCoordinates,
              Notes: jobDoc.jobInfo.core.shiftNotes,

              IsPaidJob: jobDoc.jobInfo.status.isPaidJob,
              WerkersPaid: jobDoc.jobInfo.status.isPaidWerkers,
              SchedJobStatus: jobDoc.jobInfo.status.jobStatusSched,
              WerkerJobStatus: jobDoc.jobInfo.status.jobStatusWerker,
              PaidWerker: jobDoc.jobInfo.status.isPaidWerker,
              IsNewMessage: Boolean(jobDoc.jobInfo?.status?.isNewMessage),
              IsCancelled: jobDoc.jobInfo.status.jobCancelledByScheduler,
              ScheduledCount: jobDoc.jobInfo.status.scheduledCount || 0,
            });
          });
        }
      });

      return () => {
        unsubscribe();
      };
    } catch (error) {
      // console.log(error);
    }
  }, [match.params, usersID]);

  useEffect(() => {
    const jobWerkersQuery = query(
      collectionGroup(db, FB_COLLECTION_PATH.JobsDocs),
      where("jobInfo.core.uniqueJobId", "==", match.params.uniqueJobDocId),
      where("jobInfo.status.jobStatusWerker", "in", [WORKFLOW_WERKER_TYPES.Scheduled, WORKFLOW_WERKER_TYPES.Past])
    );

    try {
      const unsubscribe2 = onSnapshot(jobWerkersQuery, (querySnapshot) => {
        const scheduledWerkersArray: any = [];
        if (querySnapshot.empty) {
        } else {
          querySnapshot.forEach((docSnap) => {
            const jobDoc: any = docSnap.data();

            // Exclude myself from the scheduled werkers list
            if (jobDoc.docStamp.userInfoTo.uid === usersID) return;

            scheduledWerkersArray.push({
              JobDocId: match.params.jobDocId,

              WerkerUid: jobDoc.docStamp.userInfoTo.uid,
              WerkerFirstName: jobDoc.docStamp.userInfoTo.firstName,
              WerkerLastName: jobDoc.docStamp.userInfoTo.lastName,
              WerkerProfilePicURL: jobDoc.docStamp.userInfoTo.profilePicURL,

              SchedulerUid: jobDoc.docStamp.userInfoFrom.uid,
              SchedFirstName: jobDoc.docStamp.userInfoFrom.firstName,
              SchedLastName: jobDoc.docStamp.userInfoFrom.lastName,
              SchedProfilePic: jobDoc.docStamp.userInfoFrom.profilePicURL,

              TotalJobSlots: jobDoc.jobInfo.core.numJobSlots,
              UniqueJobDocId: jobDoc.jobInfo.core.uniqueJobId,
              JobIdentifier: jobDoc.jobInfo.core.shiftIdentifier,
              Pay: jobDoc.jobInfo.core.pay,
              Company: jobDoc.jobInfo.core.company,
              StartDate: jobDoc.jobInfo.core.dateTimeStart,
              EndDate: jobDoc.jobInfo.core.dateTimeFinish,
              Location: jobDoc.jobInfo.core.location,
              LocationCoordinates: jobDoc.jobInfo.core.locationCoordinates,
              Notes: jobDoc.jobInfo.core.shiftNotes,

              IsPaidJob: jobDoc.jobInfo.status.isPaidJob,
              WerkersPaid: jobDoc.jobInfo.status.isPaidWerkers,
              SchedJobStatus: jobDoc.jobInfo.status.jobStatusSched,
              WerkerJobStatus: jobDoc.jobInfo.status.jobStatusWerker,
              PaidWerker: jobDoc.jobInfo.status.isPaidWerker,
              IsNewMessage: Boolean(jobDoc.jobInfo?.status?.isNewMessage),
              IsCancelled: jobDoc.jobInfo.status.jobCancelledByScheduler,
              ScheduledCount: jobDoc.jobInfo.status.scheduledCount || 0,
            });
          });
        }
        setJobDocsScheduledWerkers(scheduledWerkersArray);
      });

      return () => {
        unsubscribe2();
      };
    } catch (error) {
      // console.log(error);
    }
  }, [match.params, usersID]);

  useEffect(() => {
    const myJobQuery = query(
      collectionGroup(db, FB_COLLECTION_PATH.JobsDocs),
      where("jobInfo.core.uniqueJobId", "==", match.params.uniqueJobDocId),
      where("docStamp.userInfoTo.uid", "==", usersID)
    );

    try {
      const unsubscribe3 = onSnapshot(myJobQuery, (querySnapshot) => {
        if (querySnapshot.empty) {
        } else {
          querySnapshot.forEach((docSnap) => {
            const jobDoc: any = docSnap.data();
            setJobDocsWerker({
              JobDocId: match.params.jobDocId,

              WerkerUid: jobDoc.docStamp.userInfoTo.uid,
              WerkerFirstName: jobDoc.docStamp.userInfoTo.firstName,
              WerkerLastName: jobDoc.docStamp.userInfoTo.lastName,
              WerkerProfilePicURL: jobDoc.docStamp.userInfoTo.profilePicURL,

              SchedulerUid: jobDoc.docStamp.userInfoFrom.uid,
              SchedFirstName: jobDoc.docStamp.userInfoFrom.firstName,
              SchedLastName: jobDoc.docStamp.userInfoFrom.lastName,
              SchedProfilePic: jobDoc.docStamp.userInfoFrom.profilePicURL,

              TotalJobSlots: jobDoc.jobInfo.core.numJobSlots,
              UniqueJobDocId: jobDoc.jobInfo.core.uniqueJobId,
              JobIdentifier: jobDoc.jobInfo.core.shiftIdentifier,
              Pay: jobDoc.jobInfo.core.pay,
              Company: jobDoc.jobInfo.core.company,
              StartDate: jobDoc.jobInfo.core.dateTimeStart,
              EndDate: jobDoc.jobInfo.core.dateTimeFinish,
              Location: jobDoc.jobInfo.core.location,
              LocationCoordinates: jobDoc.jobInfo.core.locationCoordinates,
              Notes: jobDoc.jobInfo.core.shiftNotes,

              IsPaidJob: jobDoc.jobInfo.status.isPaidJob,
              WerkersPaid: jobDoc.jobInfo.status.isPaidWerkers,
              SchedJobStatus: jobDoc.jobInfo.status.jobStatusSched,
              WerkerJobStatus: jobDoc.jobInfo.status.jobStatusWerker,
              PaidWerker: jobDoc.jobInfo.status.isPaidWerker,
              IsNewMessage: Boolean(jobDoc.jobInfo?.status?.isNewMessage),
              IsCancelled: jobDoc.jobInfo.status.jobCancelledByScheduler,
              ScheduledCount: jobDoc.jobInfo.status.scheduledCount || 0,
            });
          });
        }
      });

      return () => {
        unsubscribe3();
      };
    } catch (error) {
      // console.log(error);
    }
  }, [match.params, usersID]);

  useEffect(() => {
    // jobDocsScheduledWerkers excludes "myself", so add 1 if I'm Scheduled/Past
    const iAmScheduled =
      jobDocsWerker.WerkerJobStatus === WORKFLOW_WERKER_TYPES.Scheduled ||
      jobDocsWerker.WerkerJobStatus === WORKFLOW_WERKER_TYPES.Past;
    const totalScheduled = jobDocsScheduledWerkers.length + (iAmScheduled ? 1 : 0);
    setRemainingJobSlots(jobDocsScheduler.TotalJobSlots - totalScheduled);
  }, [jobDocsScheduledWerkers, jobDocsScheduler, jobDocsWerker]);

  // Stale-invite cleanup: when the Werker opens ShiftDetails for a job whose
  // scheduler-side status is Filled or Past, but their own jobFeed doc still
  // shows them as Invited (status === "available"), flip the feed doc to
  // "expired" so the Home Invited list drops it on Back navigation. Silent,
  // best-effort, runs at most once per mount.
  const hasCleanedStaleInviteRef = useRef(false);
  useEffect(() => {
    if (hasCleanedStaleInviteRef.current) return;
    if (!usersID) return;

    const schedStatus = jobDocsScheduler.SchedJobStatus;
    const isExpiredOnSchedSide =
      schedStatus === WORKFLOW_SCHEDULER_TYPES.Filled ||
      schedStatus === WORKFLOW_SCHEDULER_TYPES.Past;
    if (!isExpiredOnSchedSide) return;

    const jobId = jobDocsScheduler.UniqueJobDocId || match.params.uniqueJobDocId;
    if (!jobId) return;

    hasCleanedStaleInviteRef.current = true;

    (async () => {
      try {
        const feedRef = doc(
          db,
          FB_COLLECTION_PATH.Users,
          usersID,
          FB_COLLECTION_PATH.JobFeed,
          jobId
        );
        const feedSnap = await getDoc(feedRef);
        if (!feedSnap.exists()) return;
        const feedData: any = feedSnap.data();
        if (feedData?.status !== "available") return;

        await setDoc(
          feedRef,
          {
            status: "expired",
            dismissed: true,
            dismissedAt: Date.now(),
            updatedAt: Date.now(),
          },
          { merge: true }
        );
      } catch (err) {
        // Silent: cleanup is best-effort and must never disrupt the view.
        // eslint-disable-next-line no-console
        console.warn("Stale invite cleanup failed", err);
      }
    })();
  }, [
    usersID,
    jobDocsScheduler.SchedJobStatus,
    jobDocsScheduler.UniqueJobDocId,
    match.params.uniqueJobDocId,
  ]);

  // --- UI helper only (display formatting) ---
  const getShiftHoursLabel = (): string => {
    try {
      const start = new Date(jobDocsScheduler.StartDate);
      const end = new Date(jobDocsScheduler.EndDate);
      const diffMs = end.getTime() - start.getTime();
      if (!Number.isFinite(diffMs)) return "";
      const diffHrs = diffMs / (1000 * 60 * 60);
      if (!Number.isFinite(diffHrs)) return "";
      const rounded = Math.round(diffHrs * 10) / 10; // e.g., 7.5
      const isWhole = Math.abs(rounded - Math.round(rounded)) < 0.0001;
      const label = isWhole ? `${Math.round(rounded)} hrs` : `${rounded} hrs`;
      return label;
    } catch (e) {
      return "";
    }
  };

  // Ensure scheduledCount exists for legacy jobs
  const ensureScheduledCountExists = async (jobDocRef: any, uniqueJobDocId: string): Promise<void> => {
    const snap = await getDoc(jobDocRef);
    if (!snap.exists()) {
      throw new Error("Job no longer exists.");
    }
    const data: any = snap.data();
    const existing = data?.jobInfo?.status?.scheduledCount;

    if (existing !== undefined) return;

    const q = query(
      collectionGroup(db, FB_COLLECTION_PATH.JobsDocs),
      where("jobInfo.core.uniqueJobId", "==", uniqueJobDocId),
      where("jobInfo.status.jobStatusWerker", "in", [WORKFLOW_WERKER_TYPES.Scheduled, WORKFLOW_WERKER_TYPES.Past])
    );
    const derivedSnap = await getDocs(q);

    await updateDoc(jobDocRef, {
      "jobInfo.status.scheduledCount": derivedSnap.size,
    });
  };

  const [isTakingJob, setIsTakingJob] = useState(false);

  const handleWerk = async () => {
    Sentry.addBreadcrumb({ category: "job", message: `Werker taking job (mobile): ${jobDocsScheduler.UniqueJobDocId}`, level: "info" });
    const jobDocRef = doc(db, FB_COLLECTION_PATH.JobsDocs, jobDocsScheduler.UniqueJobDocId);
    const myJobDocRef = doc(db, FB_COLLECTION_PATH.JobsDocs, match.params.jobDocId);

    setIsTakingJob(true);
    try {
      await ensureScheduledCountExists(jobDocRef, jobDocsScheduler.UniqueJobDocId);
      let notifyScheduler = false;

      await runTransaction(db, async (transaction) => {
        const result = await claimJobTransaction(transaction, { jobDocRef, myJobDocRef });
        notifyScheduler = result.notifyScheduler;
      });

      const myFeedRef = doc(db, FB_COLLECTION_PATH.Users, usersID, FB_COLLECTION_PATH.JobFeed, jobDocsScheduler.UniqueJobDocId);
      await setDoc(
        myFeedRef,
        {
          status: "scheduled",
          updatedAt: Date.now(),
          isRead: true,
          dismissed: false,
          dismissedAt: null,
        },
        { merge: true }
      );

      if (notifyScheduler) {
        try {
          fx_FB_SendNotification(usersID, [jobDocsScheduler.SchedulerUid], PUSH_NOTIFICATION_TYPES.SchedulerFilledJobs, {
            shiftIdentifier: jobDocsScheduler.JobIdentifier,
            uniqueJobDocId: jobDocsScheduler.UniqueJobDocId,
          });
          await fx_FB_WerkerUpdateAll(usersID, jobDocsScheduler.SchedulerUid, jobDocsScheduler.UniqueJobDocId, "");
          await fx_FB_WerkerFeedUpdateAll(usersID, jobDocsScheduler.SchedulerUid, jobDocsScheduler.UniqueJobDocId, {
            action: "filled",
          });
        } catch (notifyError) {
          console.error("[ShiftDetails] Post-take notification failed:", notifyError);
          Sentry.captureException(notifyError);
        }
      }
    } catch (error: any) {
      present({
        header: "Unable to take job",
        message: error.message ?? "Please try again.",
        buttons: ["Ok"],
      });
      Sentry.captureException(error);
    } finally {
      setIsTakingJob(false);
    }
  };

  const handleWerked = async () => {
    const werkersOnJob = query(
      collectionGroup(db, FB_COLLECTION_PATH.JobsDocs),
      where("docStamp.userInfoFrom.uid", "==", jobDocsScheduler.SchedulerUid),
      where("docStamp.userInfoTo.uid", "!=", jobDocsScheduler.SchedulerUid),
      where("jobInfo.core.uniqueJobId", "==", jobDocsScheduler.UniqueJobDocId),
      where("jobInfo.status.jobStatusWerker", "in", [WORKFLOW_WERKER_TYPES.Past])
    );

    const querySnapshot2 = await getDocs(werkersOnJob);
    const pastWerkersCount = querySnapshot2.size;

    if (
      jobDocsScheduler.SchedJobStatus === WORKFLOW_SCHEDULER_TYPES.Filled &&
      jobDocsScheduler.TotalJobSlots - pastWerkersCount === 1
    ) {
      const setJobIdSched = doc(db, FB_COLLECTION_PATH.JobsDocs, jobDocsScheduler.UniqueJobDocId);
      await updateDoc(setJobIdSched, {
        "jobInfo.status.jobStatusSched": WORKFLOW_SCHEDULER_TYPES.Past,
      });
    }

    const setJobIdMe = doc(db, FB_COLLECTION_PATH.JobsDocs, match.params.jobDocId);
    await updateDoc(setJobIdMe, {
      "jobInfo.status.jobStatusWerker": WORKFLOW_WERKER_TYPES.Past,
    });
  };

  const handleUnwerk = async () => {
    if (jobDocsScheduler.SchedJobStatus === WORKFLOW_SCHEDULER_TYPES.Past) {
      const setJobIdSched = doc(db, FB_COLLECTION_PATH.JobsDocs, jobDocsScheduler.UniqueJobDocId);
      await updateDoc(setJobIdSched, {
        "jobInfo.status.jobStatusSched": WORKFLOW_SCHEDULER_TYPES.Filled,
      });
    }
    const setJobIdMe = doc(db, FB_COLLECTION_PATH.JobsDocs, match.params.jobDocId);
    await updateDoc(setJobIdMe, {
      "jobInfo.status.jobStatusWerker": WORKFLOW_WERKER_TYPES.Scheduled,
    });
  };

  const routeToChat = () => {
    history.push({
      pathname: `/Chat/${jobDocsScheduler.UniqueJobDocId}`,
      state: {
        msgCat: "JobMsg",
      },
    });
  };

  const ScheduledWerkersList: React.FC = () => {
    if (jobDocsScheduledWerkers.length === 0) {
      return (
        <IonRow></IonRow>
      );
    }

    return (
      <React.Fragment>
        <IonItemDivider>
          <IonLabel>
            {jobDocsScheduler.IsCancelled ? "Werkers" : "Scheduled"}
          </IonLabel>
        </IonItemDivider>

        <IonList>
          {jobDocsScheduledWerkers.map((Werker: any) => (
            <IonItem
              key={Werker.WerkerUid}
              button={true}
              onClick={(_e) => {
                LinkToProfile(Werker.WerkerUid);
              }}
            >
              <IonAvatar
                className="avatario"
                style={{ height: "30px", width: "30px" }}
                slot="start"
              >
                <img src={Werker.WerkerProfilePicURL} alt="" />
              </IonAvatar>
              <IonLabel
                className="labelo"
                style={{ fontWeight: 500, fontSize: "0.9rem", opacity: 0.95 }}
              >
                {Werker.WerkerFirstName} {Werker.WerkerLastName}
              </IonLabel>
            </IonItem>
          ))}
        </IonList>
      </React.Fragment>
    );
  };

  const ShiftDetailsChatButtonWithAlert: React.FC = () => {
    return (
      <React.Fragment>
        <IonFab
          slot="fixed"
          horizontal="end"
          vertical="bottom"
        >
          <IonFabButton
            color="warning"
            style={{
              marginBottom: "40px",
              // "--background": "transparent",
              // "--background-activated": "rgba(255,255,255,0.08)",
              // "--background-hover": "rgba(255,255,255,0.06)",
              // "--color": "var(--ion-color-medium-contrast)",
              "--border-radius": "15px",
              "--box-shadow": "0 10px 26px rgba(0,0,0,0.35), 0 0 0 1px rgba(255,255,255,0.10)",
            }}
            onClick={routeToChat}
          >
            <IonIcon
              icon={chatboxOutline}
            />
            <IonBadge
              color="danger"
              style={{
                position: "absolute",
                top: "7px",
                right: "7px",
              }}
            >
              {"1"}
            </IonBadge>
          </IonFabButton>
        </IonFab>
      </React.Fragment>
    );
  };

  const ShiftDetailsChatButtonWithoutAlert: React.FC = () => {
    return (
      <React.Fragment>
        <IonFab
          slot="fixed"
          horizontal="end"
          vertical="bottom"
        >
          <IonFabButton
            color="warning"
            style={{
              marginBottom: "40px",
              // "--background": "transparent",
              // "--background-activated": "rgba(255,255,255,0.08)",
              // "--background-hover": "rgba(255,255,255,0.06)",
              // "--color": "var(--ion-color-medium-contrast)",
              "--border-radius": "15px",
              "--box-shadow": "0 10px 26px rgba(0,0,0,0.35), 0 0 0 1px rgba(255,255,255,0.10)",
            }}
            onClick={routeToChat}
          >
            <IonIcon
              size="large"
              // color="dark"
              icon={chatboxOutline}
            />
          </IonFabButton>
        </IonFab>
      </React.Fragment>
    );
  };

  const _handleClearOneBadge = async (isReadBool: boolean, jobDocNum: string) => {
    if (isReadBool === false) {
      const seenJobId = doc(db, FB_COLLECTION_PATH.JobsDocs, jobDocNum);
      await updateDoc(seenJobId, {
        "jobInfo.status.isRead": true,
      });
    }
    return { cleared: "yes" };
  };

  const [_presentLoading] = useIonLoading();

  const blurFocusedElement = useCallback(() => {
    let activeElement: Element | null = document.activeElement;

    while (activeElement && (activeElement as HTMLElement).shadowRoot?.activeElement) {
      activeElement = (activeElement as HTMLElement).shadowRoot?.activeElement || null;
    }

    if (activeElement instanceof HTMLElement && activeElement !== document.body) {
      activeElement.blur();
    }

    const hostElement = document.activeElement;
    if (hostElement instanceof HTMLElement && hostElement !== document.body) {
      hostElement.blur();
    }
  }, []);

  useIonViewWillLeave(() => {
    blurFocusedElement();
  });

  const AvailableJobButton: React.FC = () => {
    return (
      <React.Fragment>
        <IonRow
          style={{ marginBottom: 12 }}
        >
          <IonCol></IonCol>

          {/* <IonCol size="2">
            <IonButton
              onClick={() => handleJobNavigation("left")}
              color="medium"
              style={{
                margin: 0,
                height: 42,
              }}
              expand="block"
            >
              <IonIcon
                size="large"
                icon={chevronBackOutline}
              ></IonIcon>
            </IonButton>
          </IonCol> */}

          <IonCol size="11">
            <IonButton
              onClick={() =>
                present({
                  header: "Werk This Job?",
                  buttons: ["Cancel", { text: "Ok", handler: handleWerk }],
                  onDidDismiss: (_e) => {},
                })
              }
              color="warning"
              style={{
                margin: 0,
                height: 42,
              }}
              fill="solid"
              expand="block"
            >
              Take the Job
            </IonButton>
          </IonCol>

          {/* <IonCol size="2">
            <IonButton
              onClick={() => handleJobNavigation("right")}
              color="medium"
              style={{
                margin: 0,
                height: 42,
              }}
              expand="block"
            >
              <IonIcon
                size="large"
                icon={chevronForwardOutline}
              ></IonIcon>
            </IonButton>
          </IonCol> */}

          <IonCol></IonCol>
        </IonRow>
      </React.Fragment>
    );
  };

  const ScheduledJobButton: React.FC = () => {
    return (
      <React.Fragment>
        <IonRow
          style={{ marginBottom: 12 }}
        >
          <IonCol></IonCol>

          <IonCol size="9">
            <IonButton
              onClick={() =>
                {
                  blurFocusedElement();
                  present({
                    header: `Mark as "Completed"?`,
                    buttons: [
                      "Cancel",
                      {
                        text: "Ok",
                        handler: async () => {
                          blurFocusedElement();
                          await handleWerked();
                        },
                      },
                    ],
                  });
                }
              }
              color="warning"
              style={{
                margin: 0,
                height: 42,
              }}
              fill="solid"
              expand="block"
            >
              Done
            </IonButton>
          </IonCol>

          <IonCol size="2">
            <IonButton
              onClick={() =>
                present({
                  header: "Contact Scheduler to quit job.",
                  buttons: ["Ok"],
                })
              }
              color="danger"
              style={{
                margin: 0,
                height: 42,
              }}
              expand="block"
            >
              <IonIcon
                size="large"
                icon={closeSharp}
              ></IonIcon>
            </IonButton>
          </IonCol>

          <IonCol></IonCol>
        </IonRow>
      </React.Fragment>
    );
  };

  const PastJobButton: React.FC = () => {
    return (
      <React.Fragment>
        <IonRow
          style={{ marginBottom: 12 }}
        >
          <IonCol></IonCol>

          <IonCol size="9">
            <IonButton
              color="warning"
              style={{
                margin: 0,
                height: 42,
              }}
              fill="solid"
              expand="block"
            >
              Completed
            </IonButton>
          </IonCol>

          {jobDocsScheduler.WerkersPaid === true && <div></div>}

          {jobDocsScheduler.WerkersPaid !== true && jobDocsScheduler.IsCancelled === false && (
            <IonCol
              size="2"
            >
              <IonButton
                onClick={() =>
                  present({
                    header: "Undo?",
                    buttons: ["Cancel", { text: "Ok", handler: handleUnwerk }],
                  })
                }
                color="medium"
                style={{
                  margin: 0,
                  height: 42,
                }}
                fill="solid"
                expand="block"
              >
                <IonIcon
                  icon={arrowUndoOutline}
                />
              </IonButton>
            </IonCol>
          )}

          <IonCol></IonCol>
        </IonRow>
      </React.Fragment>
    );
  };

  const PaidJobButton: React.FC = () => {
    return (
      <React.Fragment>
        <IonRow
          class="ion-justify-content-center"
          style={{ marginBottom: 12 }}
        >
          <IonCol
            class="ion-justify-content-center"
          >
            <IonCol
              size="2"
            >
              <IonButton
                color="medium"
                style={{
                  margin: 0,
                  height: 42,
                }}
                fill="outline"
                expand="block"
              >
                <h1>
                  <IonIcon
                    icon={cashOutline}
                  />
                </h1>
              </IonButton>
            </IonCol>
          </IonCol>
        </IonRow>
      </React.Fragment>
    );
  };

  const ExpiredJobButton: React.FC = () => {
    return (
      <React.Fragment>
        <IonRow
          style={{ marginBottom: 12 }}
        >
          <IonCol></IonCol>

          

          <IonCol size="11">
            <IonButton
              color="danger"
              style={{
                margin: 0,
                height: 42,
              }}
              fill="solid"
              expand="block"
            >
              Expired
            </IonButton>
          </IonCol>

          <IonCol></IonCol>
        </IonRow>
      </React.Fragment>
    );
  };

  const openInGoogleMaps = () => {
    const { googleMapsUrl } = generateMapUrls(jobDocsScheduler.LocationCoordinates);
    window.open(googleMapsUrl, "_blank");
  };

  const openInAppleMaps = () => {
    if (
      jobDocsScheduler.LocationCoordinates.startsWith("https://maps.apple.com/") ||
      jobDocsScheduler.LocationCoordinates.startsWith("maps:")
    ) {
      window.open(jobDocsScheduler.LocationCoordinates);
    } else {
      const { appleMapsUrl } = generateMapUrls(jobDocsScheduler.LocationCoordinates);
      window.open(appleMapsUrl);
    }
  };

  interface werkerJobButtons {
    display: string;
    paid: boolean;
  }

  const JobSummaryActions: React.FC<werkerJobButtons> = (buttonStatus) => {
    if (buttonStatus.display === WORKFLOW_WERKER_TYPES.Scheduled) return <ScheduledJobButton />;
    if (buttonStatus.display === WORKFLOW_WERKER_TYPES.Cancelled) return <PastJobButton />;
    if (buttonStatus.display === WORKFLOW_WERKER_TYPES.Past && buttonStatus.paid === true) return <PaidJobButton />;
    if (buttonStatus.display === WORKFLOW_WERKER_TYPES.Past) return <PastJobButton />;
    if (buttonStatus.display === WORKFLOW_WERKER_TYPES.Expired) return <ExpiredJobButton />;
    if (buttonStatus.display === WORKFLOW_WERKER_TYPES.Deleted) return <ExpiredJobButton />;
    // Guard: if all slots are filled, show disabled state instead of "Take the Job"
    if (remainingJobSlots <= 0 && jobDocsScheduler.TotalJobSlots > 0) {
      return (
        <IonRow style={{ marginBottom: 12 }}>
          <IonCol></IonCol>
          <IonCol size="11">
            <IonButton
              color="medium"
              fill="solid"
              expand="block"
              disabled={true}
              style={{ margin: 0, height: 42 }}
            >
              Job Full
            </IonButton>
          </IonCol>
        </IonRow>
      );
    }
    return <AvailableJobButton />;
  };

  const SchedJobDataComponent: React.FC = () => {
    const start = new Date(jobDocsScheduler.StartDate);
    const end = new Date(jobDocsScheduler.EndDate);

    const startOk = Number.isFinite(start.getTime());
    const endOk = Number.isFinite(end.getTime());

    // Check whether the shift spans multiple calendar days
    const sameDay =
      startOk && endOk &&
      start.getFullYear() === end.getFullYear() &&
      start.getMonth() === end.getMonth() &&
      start.getDate() === end.getDate();

    const hoursLabel = getShiftHoursLabel();

    const hasNotes = typeof jobDocsScheduler.Notes === "string" && jobDocsScheduler.Notes.trim().length > 0;

    const hasCoordText =
      typeof jobDocsScheduler.LocationCoordinates === "string" &&
      jobDocsScheduler.LocationCoordinates.trim().length > 0;

    // tighter label (not an IonItem) so it stays close to what it labels
    const SectionLabelTight: React.FC<{ text: string; mt?: number }> = ({ text, mt = 10 }) => (
      <div
        style={{
          marginTop: mt,
          marginBottom: 4,
          paddingLeft: 16,
          paddingRight: 16,
          fontSize: "0.8rem",
          letterSpacing: "0.03em",
          opacity: 0.65,
          textTransform: "uppercase",
          fontWeight: 600,
        }}
      >
        {text}
      </div>
    );

    const SoftDivider: React.FC<{ mt?: number; mb?: number }> = ({ mt = 12, mb = 10 }) => (
      <div
        style={{
          height: 1,
          opacity: 0.12,
          margin: `${mt}px 16px ${mb}px 16px`,
          background: "currentColor",
        }}
      />
    );

    const NotesSection: React.FC = () => {
      const defaultValue = hasNotes ? "notes" : undefined;

      return (
        <IonAccordionGroup
          value={defaultValue}
        >
          <IonAccordion
            value="notes"
          >
            <IonItem
              slot="header"
              lines="none"
              button={true}
            >
              <IonLabel
                style={{
                  fontSize: "0.8rem",
                  letterSpacing: "0.03em",
                  opacity: 0.65,
                  textTransform: "uppercase",
                  fontWeight: 600,
                }}
              >
                Notes
              </IonLabel>
            </IonItem>

            <div slot="content" style={{ padding: "10px 16px 6px 16px" }}>
              {hasNotes ? (
                <IonText
                  style={{ opacity: 0.88, fontSize: "0.98rem" }}
                >
                  {parseNotes2(jobDocsScheduler.Notes)}
                </IonText>
              ) : (
                <IonText
                  style={{ opacity: 0.55, fontSize: "0.95rem" }}
                >
                  No notes.
                </IonText>
              )}
            </div>
          </IonAccordion>
        </IonAccordionGroup>
      );
    };

    const StatusStrip: React.FC = () => {
      const remainingSlotsText = jobDocsWerker.IsCancelled
        ? "Remaining Slots: —"
        : `Remaining Slots: ${remainingJobSlots}`;

      return (
        <IonItem
          lines="none"
          color="light"
          style={{
            "--background": "var(--ion-color-light-shade)",
            "--min-height": "36px",
            "--padding-start": "12px",
            "--padding-end": "12px",
            borderTop: "1px solid var(--ion-color-light-shade)",
            borderBottom: "1px solid var(--ion-color-light-shade)",
            marginBottom: "10px",
          }}
        >
          <IonLabel
            style={{ minWidth: 0, opacity: 0.9, fontSize: "0.9rem" }}
          >
            <span style={{ fontWeight: 600 }}>{remainingSlotsText}</span>
          </IonLabel>

          {jobDocsWerker.IsCancelled === true && (
            <IonText
              slot="end"
              color="danger"
              style={{ fontWeight: 800, letterSpacing: "0.04em" }}
            >
              CANCELLED
            </IonText>
          )}
        </IonItem>
      );
    };

    return (
      <React.Fragment>
        {/* Scheduler row */}
        <IonItem
          className="shdtls"
          style={{ marginTop: -5 }}
          button={true}
          onClick={(_e) => {
            LinkToProfile(jobDocsScheduler.SchedulerUid);
          }}
        >
          <IonAvatar
            className="tinyavatar"
            slot="start"
          >
            <img src={jobDocsScheduler.SchedProfilePic} alt="" />
          </IonAvatar>

          <IonLabel>
            <div style={{ fontWeight: 500, fontSize: "0.9rem", opacity: 0.95 }}>
              {jobDocsScheduler.SchedFirstName} {jobDocsScheduler.SchedLastName}
            </div>
            <IonText
              style={{ fontSize: "0.85rem", opacity: 0.7 }}
            >
              <span>Scheduler</span>
            </IonText>
          </IonLabel>
        </IonItem>

        <IonList
          lines="inset"
        >
          {/* Organization */}
          <IonItem
            lines="none"
          >
            <IonLabel>
              <div style={{ fontWeight: 700, opacity: 0.92, whiteSpace: "normal" }}>{jobDocsScheduler.Company}</div>
              <IonText
                style={{ fontSize: "0.92rem", opacity: 0.72 }}
              >
                <span>{jobDocsScheduler.JobIdentifier}</span>
              </IonText>
            </IonLabel>
          </IonItem>

          {/*(2 rows: date line, then time/hours split) */}
          <IonItem
            lines="none"
          >
            <IonLabel>
              {sameDay ? (
                <>
                  <div style={{ fontWeight: 550, opacity: 0.92 }}>
                    {startOk ? format(start, "EEE • MMM d, yy") : "—"}
                  </div>
                  <div
                    style={{
                      marginTop: 4,
                      display: "flex",
                      justifyContent: "space-between",
                      gap: 12,
                      opacity: 0.88,
                      fontSize: "0.96rem",
                    }}
                  >
                    <span style={{ whiteSpace: "nowrap" }}>
                      {startOk && endOk
                        ? `${format(start, "h:mma")} – ${format(end, "h:mma")}`
                        : "—"}{" "}
                      • {hoursLabel}
                    </span>
                  </div>
                </>
              ) : (
                <>
                  <div style={{ fontWeight: 450, opacity: 0.92, fontSize: "0.95rem" }}>
                    <span style={{ fontSize: "0.75rem", opacity: 0.55, textTransform: "uppercase", letterSpacing: "0.04em", marginRight: 6 }}>Start</span>
                    {startOk ? `${format(start, "EEE • MMM d, yy")} • ${format(start, "h:mma")}` : "—"}
                  </div>
                  <div style={{ fontWeight: 450, opacity: 0.92, fontSize: "0.95rem", marginTop: 3 }}>
                    <span style={{ fontSize: "0.75rem", opacity: 0.55, textTransform: "uppercase", letterSpacing: "0.04em", marginRight: 6 }}>End</span>
                    {endOk ? `${format(end, "EEE • MMM d, yy")} • ${format(end, "h:mma")}` : "—"}
                  </div>
                  {hoursLabel && (
                    <div style={{ marginTop: 4, opacity: 0.65, fontSize: "0.88rem" }}>
                      {hoursLabel} total
                    </div>
                  )}
                </>
              )}
            </IonLabel>
          </IonItem>

          {/* Pay */}
          <IonItem
            lines="none"
          >
            <IonLabel
              style={{ minWidth: 0 }}
            >
              <div style={{ fontWeight: 750, fontSize: "1.06rem", opacity: 0.92, whiteSpace: "normal" }}>
                {jobDocsScheduler.Pay}
              </div>
            </IonLabel>

            {jobDocsWerker.PaidWerker === true && (
              <IonText
                slot="end"
                color="success"
                style={{
                  fontWeight: 800,
                  letterSpacing: "0.04em",
                  whiteSpace: "nowrap",
                  opacity: 0.95,
                }}
              >
                <span>PAID</span>
              </IonText>
            )}
          </IonItem>

          <StatusStrip />

          {/* Location */}
          {/* <SoftDivider mt={12} mb={8} /> */}
          <SectionLabelTight text="Location" mt={0} />
          <IonItem
            lines="none"
          >
            <IonLabel
              style={{ userSelect: "text" }}
            >
              {hasCoordText && (
                <div style={{ fontWeight: 650, opacity: 0.92, whiteSpace: "normal" }}>
                  {jobDocsScheduler.LocationCoordinates}
                </div>
              )}
              <div style={{ marginTop: hasCoordText ? 6 : 0, opacity: 0.88, whiteSpace: "normal" }}>
                {jobDocsScheduler.Location}
              </div>
            </IonLabel>

            {hasCoordText ? (
              <IonButton
                slot="end"
                size="small"
                color="secondary"
                onClick={(_e) => {
                  present({
                    header: "Open with:",
                    buttons: [
                      { text: "Apple Maps", handler: openInAppleMaps },
                      { text: "Google Maps", handler: openInGoogleMaps },
                      "Cancel",
                    ],
                    onDidDismiss: (_ev) => {},
                  });
                }}
              >
                <IonIcon
                  icon={navigate}
                />
              </IonButton>
            ) : (
              <IonButton
                slot="end"
                size="small"
                color="medium"
                onClick={(_e) => {
                  present({
                    header: "No map data provided",
                    buttons: ["Ok"],
                    onDidDismiss: (_ev) => {},
                  });
                }}
              >
                <IonIcon
                  icon={navigate}
                />
              </IonButton>
            )}
          </IonItem>

          {/* Notes (with space before Werkers list below in the page) */}
          <SoftDivider mt={12} mb={8} />
          <NotesSection />
          <SoftDivider mt={10} mb={16} />
        </IonList>
      </React.Fragment>
    );
  };

  return (
    <IonPage>
      {isLoadingShiftData && (
        <IonContent
          className="bckgrnd"
          style={{ "--background": "#ffc409" } as any}
        >
          <div
            style={{
              minHeight: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <LoadingScreen LoadingText="" />
          </div>
        </IonContent>
      )}

      <IonLoading
        isOpen={isTakingJob}
        message="Taking job…"
        spinner="crescent"
        cssClass="custom-loading-transparent"
        backdropDismiss={false}
      />

      <IonAlert
        isOpen={hasTimedOutShiftData}
        header="Job couldn't load. Please try again."
        backdropDismiss={false}
        buttons={[
          {
            text: "OK",
            handler: navigateBackWithFallback,
          },
        ]}
      />

      {!isLoadingShiftData && !hasTimedOutShiftData && (
        <>
          <WerkerSchedulerHeader
            title={HEADERTEXT_TYPES.ShiftDetails}
            endSlot={
              <IonButton
                fill="clear"
                style={{ "--padding-start": "6px", "--padding-end": "6px" } as any}
                onClick={() => {
                  presentSupportConfirm({
                    header: "Send job to support?",
                    message: "Our support team will review this job and get back to you via message.",
                    buttons: [
                      { text: "Cancel", role: "cancel" },
                      { text: "OK", handler: () => setShowSupportDetails(true) },
                    ],
                  });
                }}
              >
                <IonAvatar style={{ width: "28px", height: "28px" }}>
                  <img src={SUPPORT_MONKEY_ASSOCIATE.WerkerProfilePicURL} alt="Support" />
                </IonAvatar>
              </IonButton>
            }
          />

          {/* Support details modal */}
          <IonModal
            isOpen={showSupportDetails}
            onDidDismiss={() => { setShowSupportDetails(false); setSupportNote(""); }}
            initialBreakpoint={0.5}
            breakpoints={[0, 0.5, 0.75]}
          >
            <IonHeader>
              <IonToolbar>
                <IonTitle style={{ fontSize: "1rem" }}>Add Details (Optional)</IonTitle>
              </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
              <IonTextarea
                placeholder="Describe the issue (optional)..."
                autoGrow={true}
                rows={4}
                maxlength={500}
                spellCheck={true}
                autoCapitalize="sentences"
                value={supportNote}
                onIonChange={(e) => setSupportNote(e.detail.value || "")}
                style={{ marginBottom: "16px" }}
              />
              <IonButton
                expand="block"
                color="success"
                strong={true}
                disabled={isSendingToSupport}
                onClick={async () => {
                  setShowSupportDetails(false);
                  setIsSendingToSupport(true);
                  try {
                    await sendJobToSupport({
                      profile,
                      uniqueJobId: match.params.uniqueJobDocId,
                      schedUid: match.params.schedUid,
                      shiftIdentifier: jobDocsWerker.JobIdentifier || jobDocsScheduler.JobIdentifier || "Job",
                      viewType: "werker",
                      userNote: supportNote,
                      startDate: jobDocsWerker.StartDate || jobDocsScheduler.StartDate || "",
                      location: jobDocsWerker.Location || jobDocsScheduler.Location || "",
                      docId: jobDocsWerker.JobDocId || match.params.jobDocId || "",
                      seriesIndex: null,
                      seriesTotal: null,
                    });
                    setSupportNote("");
                    presentToast({ message: "Message sent to support \uD83D\uDC12", duration: 1500, position: "top", color: "medium" });
                  } catch (err) {
                    console.error("sendJobToSupport error:", err);
                    presentToast({ message: "Failed to send. Please try again.", duration: 2000, position: "top", color: "danger" });
                  } finally {
                    setIsSendingToSupport(false);
                  }
                }}
              >
                Send
              </IonButton>
              <IonButton
                expand="block"
                fill="clear"
                onClick={() => { setShowSupportDetails(false); setSupportNote(""); }}
              >
                Cancel
              </IonButton>
            </IonContent>
          </IonModal>

          <IonContent>
            <IonGrid>
              <SchedJobDataComponent />
              <ScheduledWerkersList />
            </IonGrid>

            {jobDocsWerker.IsNewMessage ? <ShiftDetailsChatButtonWithAlert /> : <ShiftDetailsChatButtonWithoutAlert />}
          </IonContent>

          <IonFooter>
            <IonToolbar
              style={{
                paddingBottom: "env(safe-area-inset-bottom)",
              }}
            >
              <JobSummaryActions display={jobDocsWerker.WerkerJobStatus} paid={jobDocsWerker.PaidWerker} />
            </IonToolbar>
          </IonFooter>
        </>
      )}
    </IonPage>
  );
});

export default ShiftDetails;
